// src/utils/extractors.js

function safeJSON(str) {
  try {
    return JSON.parse(str);
  } catch {
    return null;
  }
}

function getDecodedRaw(raw) {
  let decoded = typeof raw === "string" ? safeJSON(raw) : raw;
  if (decoded && typeof decoded.Result === "string") {
    const parsed = safeJSON(decoded.Result);
    if (parsed) decoded = parsed;
  } else if (decoded && typeof decoded.Result === "object") {
    decoded = decoded.Result;
  }

  if (decoded && typeof decoded.Data === "string") {
    const dataParsed = safeJSON(decoded.Data);
    if (dataParsed) {
      decoded.Data = dataParsed;
    }
  }
  return decoded;
}

export function extractUniversal(raw, entityKey) {
  let decoded = getDecodedRaw(raw);
  if (!decoded) return [];

  let data = decoded.Data || decoded;

  // 1. If explicit entityKey (array or stringified array)
  if (entityKey && Array.isArray(data[entityKey])) return data[entityKey];
  if (entityKey && typeof data[entityKey] === "string") {
    const arr = safeJSON(data[entityKey]);
    if (Array.isArray(arr)) return arr;
  }
  // 2. First array property in object
  for (const k of Object.keys(data)) {
    if (Array.isArray(data[k])) return data[k];
    if (typeof data[k] === "string") {
      const arr = safeJSON(data[k]);
      if (Array.isArray(arr)) return arr;
    }
  }
  // 3. Direct array at root
  if (Array.isArray(data)) return data;
  // 4. Fallback: wrap object as array
  if (typeof data === "object") return [data];
  return [];
}

export function extractEntityData(entity, raw) {
  const decodedRaw = getDecodedRaw(raw);

  switch (entity) {
    case "ItemsXrwma": {
      let rows = [];
      if (decodedRaw?.Data?.ItemsXrwma && Array.isArray(decodedRaw.Data.ItemsXrwma))
        rows = decodedRaw.Data.ItemsXrwma;
      else if (decodedRaw?.Data?.Apografi && Array.isArray(decodedRaw.Data.Apografi))
        rows = decodedRaw.Data.Apografi;
      else if (Array.isArray(decodedRaw?.ItemsXrwma))
        rows = decodedRaw.ItemsXrwma;
      else if (Array.isArray(decodedRaw?.Apografi))
        rows = decodedRaw.Apografi;
      else if (Array.isArray(decodedRaw))
        rows = decodedRaw;
      return rows.map((entry, idx) => ({
        key: `${entry.ProductCode}-${entry.Attribute01}-${entry.Attribute02}-${entry.Attribute03}-${idx}`,
        ProductCode: entry.ProductCode,
        Pylon_Item_ID: entry.Pylon_Item_ID,
        Xrwma: entry.Attribute01 || "",
        Megethos: entry.Attribute02 || "",
        Styl: entry.Attribute03 || "",
        XrwmaID: entry.Attributeheid01 || "",
        MegethosID: entry.Attributeheid02 || "",
        StylID: entry.Attributeheid03 || "",
        XrwmaType: entry.AttributeType01 || "",
        MegethosType: entry.AttributeType02 || "",
        StylType: entry.AttributeType03 || "",
        XrwmaTypeID: entry.AttributeTypeheid01 || "",
        MegethosTypeID: entry.AttributeTypeheid02 || "",
        StylTypeID: entry.AttributeTypeheid03 || "",
        Stock: entry.Stock,
        Barcode: entry.Barcode,
        Price: entry.Price,
      }));
    }
    case "CustBalance":
      return extractUniversal(decodedRaw, "Balance").map((entry, idx) => ({
        key: entry.Pylon_Customer_ID || `row_${idx}`,
        ...entry,
      }));
    case "Barcodes":
      return extractUniversal(decodedRaw, "Barcodes").map((entry, idx) => ({
        key: entry.Pylon_Barcode_ID || entry.Pylon_Item_ID || `row_${idx}`,
        ...entry,
      }));
    case "SerialNumbers":
      return extractUniversal(decodedRaw, "SerialNumbers").map((entry, idx) => ({
        key: entry.PylonSerialNumberID || entry.SerialNumberID || entry.PylonItemID || `row_${idx}`,
        ...entry,
      }));
    case "Contacts":
      const seen = new Set();
      return extractUniversal(decodedRaw, "Contacts").map((entry, idx) => {
        let baseKey =
          entry.Pylon_Contact_ID ||
          entry.Code ||
          entry.Pylon_Customer_ID ||
          `row_${idx}`;
        if (seen.has(baseKey)) {
          baseKey = `${baseKey}_${idx}`;
        }
        seen.add(baseKey);
        return {
          key: baseKey,
          ...entry,
        };
      });
    case "BankCNT":
      return extractUniversal(decodedRaw, "Banks").map((entry, idx) => ({
        key: entry.Pylon_Bank_ID || `row_${idx}`,
        ...entry,
      }));
    case "BanksCMP":
      return extractUniversal(decodedRaw, "CompBanks").map((entry, idx) => ({
        key: entry.Pylon_Bank_ID || `row_${idx}`,
        ...entry,
      }));
    case "Cards": {

    let cards = [];
    if (Array.isArray(decodedRaw)) {
      cards = decodedRaw;
    } else if (decodedRaw && Array.isArray(decodedRaw.Cards)) {
      cards = decodedRaw.Cards;
    } else if (decodedRaw && decodedRaw.Data && Array.isArray(decodedRaw.Data.Cards)) {
      cards = decodedRaw.Data.Cards;
    } else {
    }

    const result = cards.map((entry, idx) => ({
      key: entry.Pylon_Card_ID || `row_${idx}`,
      ...entry,
    }));

    return result;
  }

    case "Doys":
      return extractUniversal(decodedRaw, "Doy").map((entry, idx) => ({
        key: entry.Pylon_Doy_ID || `row_${idx}`,
        ...entry,
      }));
    case "AddressSc":
      return extractUniversal(decodedRaw, "Addresses").map((entry, idx) => ({
        key: entry.Pylon_Address_ID || `row_${idx}`,
        ...entry,
      }));
    case "SupplBrSc":
      return extractUniversal(decodedRaw, "SupplBranch").map((entry, idx) => ({
        key: entry.Pylon_SupplierBranch_ID || entry.Pylon_TraderBranch_ID || `row_${idx}`,
        ...entry,
      }));
    case "Company":
      return extractUniversal(decodedRaw, "Company").map((entry, idx) => ({
        key: entry.AFM || entry.Name || `row_${idx}`,
        ...entry,
      }));
    case "VatStatus":
      return extractUniversal(decodedRaw, "VatStatus").map((entry, idx) => ({
        key: entry.Pylon_VatStatus_ID || `row_${idx}`,
        ...entry,
      }));
    case "VatCategory":
      return extractUniversal(decodedRaw, "Vats").map((entry, idx) => ({
        key: entry.Pylon_VatCategory_ID || `row_${idx}`,
        ...entry,
      }));
    case "ItemsGet":
      return extractUniversal(decodedRaw, "Items").map((entry, idx) => ({
        key: entry.ItemCode || entry.Pylon_ID || `row_${idx}`,
        ...entry,
      }));
    case "ApografiSC":
      if (Array.isArray(raw)) return raw;
      return extractUniversal(decodedRaw, "Census").map((entry, idx) => ({
        key: entry.id || entry.ID || `row_${idx}`,
        ...entry,
      }));
    case "LotnumbersG":
      return extractUniversal(decodedRaw, "Lotnumbers").map((entry, idx) => ({
        key: entry.PylonLotNumberID || entry.PylonItemID || `row_${idx}`,
        ...entry,
      }));
    default:
      return extractUniversal(decodedRaw, getEntityKey(entity)).map((row, idx) => ({
        key: row?.id || row?.ID || Object.values(row)[0] || `row_${idx}`,
        ...row,
      }));
  }
}

export function getEntityKey(entity) {
  const map = {
    CustBalance: "Balance",
    Barcodes: "Barcodes",
    SerialNumbers: "SerialNumbers",
    Contacts: "Contacts",
    ItemsGet: "Items",
    AddressSc: "Addresses",
    OrdersHead: "Orders",
    OrdersSalesB: "Entries",
    PriceLists: "PriceLists",
    PriceZones: "PriceZones",
    Series: "Series",
    PaymMethod: "PaymentMethods",
    Warehouses: "Warehouses",
    BankCNT: "Banks",
    Cards: "Cards",
    BanksCMP: "CompBanks",
    Company: "Company",
    Doys: "Doy",
    VatStatus: "VatStatus",
    LotnumbersG: "Lotnumbers",
    ItemsXrwma: "Apografi",
    VatCategory: "Vats",
    TransportM: "TransportM",
    MeasurUnit: "Measurements",
    SupplBrSc: "SupplBranch",
  };
  return map[entity] || null;
}

// Named extractor wrappers kept for existing component imports.
export function extractContacts(raw) {
  return extractEntityData("ContaContactsctsV3Sc", raw);
}
export function extractSeries(raw) {
  return extractUniversal(raw, "Series");
}
export function extractPayMethods(raw) {
  return extractUniversal(raw, "PaymentMethods");
}
export function extractWarehouses(raw) {
  return extractUniversal(raw, "Warehouses");
}
export function extractCensus(raw) {
  return extractUniversal(raw, "Census");
}
export function extractBanks(raw) {
  return extractEntityData("BankCNT", raw);
}
export function extractCards(raw) {
  return extractEntityData("Cards", raw);
}
export function extractBranches(raw) {
  return extractEntityData("AddressSc", raw).map((entry) => ({
    value: entry.Pylon_Address_ID,
    label: entry.Name || entry.Address || entry.Pylon_Address_ID,
    ...entry,
  }));
}
